import { DefaultLogger, WebsocketClientV1, WSClientConfigurableOptions, WsKey } from "libs/binance-api/src";
import { MarketLoggerService, WsRequestLogRow } from "./market-logger.service";
import { cloneDeep } from "lodash-es";
import { BinanceUsdmRestClient } from "./binance-rest-client";

export class BinanceWebsocketClient extends WebsocketClientV1 {

  constructor(options: WSClientConfigurableOptions, logger: typeof DefaultLogger, private marketLogger: MarketLoggerService) {
    super(options, logger)

    this.restClientCache.restClients.usdmFutures = new BinanceUsdmRestClient(this.getRestClientOptions(), this.options.requestOptions, this.marketLogger)

    this.on('open', ({wsKey, ws}) => this.logNetworkEvent(wsKey, ws, 'client', 'open'))
    this.on('close', ({wsKey, ws}) => this.logNetworkEvent(wsKey, ws, 'client', 'close'))
    this.on('reconnected', ({wsKey, ws}) => this.logNetworkEvent(wsKey, ws, 'client', 'reconnect'))
    this.on('formattedMessage', data => this.logMessageEvent(data, 'message'))
    this.on('reply', data => this.logMessageEvent(data, 'response'))
    this.on('error', data => this.logMessageEvent(data, 'error'))
  }

  public override tryWsSend(wsKey: WsKey, wsMessage: string) {
    // Логироваине исходящих сообщений
    let payload: any
    try {
      payload = JSON.parse(wsMessage)
      payload = this.logFilter(payload)
    } catch {
      payload = undefined
    }

    if (payload) {
      const logRow: WsRequestLogRow = {
        time: Date.now(),
        market: 'binance',
        type: 'ws',
        wsKey: wsKey,
        side: 'client',
        event: 'request',
        payload: payload,
      }
      this.marketLogger.log(logRow)
    }

    return super.tryWsSend(wsKey, wsMessage)
  }

  private logFilter(payload: any): any {
    // Игнорируем потоки, кроме ORDER_TRADE_UPDATE и TRADE_LITE
    if ('eventType' in payload && !['ORDER_TRADE_UPDATE', 'TRADE_LITE'].includes(payload.eventType)) {
      return undefined
    }
    payload = cloneDeep(payload)
    delete payload.wsKey
    delete payload.wsMarket
    return payload
  }

  private logNetworkEvent(wsKey: WsKey, event: any, side: WsRequestLogRow['side'], logEventName: WsRequestLogRow['event']) {
    const logRow: WsRequestLogRow = {
      time: Date.now(),
      market: 'binance',
      type: 'ws',
      wsKey: this.trimWsKey(wsKey),
      side: side,
      event: logEventName,
      payload: {}
    }
    if ('target' in event) {
      logRow.payload.url = this.trimWsUrl((event.target as WebSocket).url)
    }
    this.marketLogger.log(logRow)
  }

  private logMessageEvent(data: any & {wsKey: WsKey, isWSAPIResponse?: boolean}, logEventName: WsRequestLogRow['event']) {
    const wsKey = this.trimWsKey(data.wsKey)
    const payload = this.logFilter(data)
    if (payload) {
      const logRow: WsRequestLogRow = {
        time: Date.now(),
        market: 'binance',
        type: 'ws',
        wsKey: wsKey,
        side: 'server',
        event: logEventName,
        payload: payload
      }
      this.marketLogger.log(logRow)
    }
  }

  private trimWsKey(wsKey: string) {
    return wsKey.replace(/_userData__.*/, '_userData')
  }

  private trimWsUrl(url: string) {
    return url.replace(/binance.com\/ws\/.*/, 'binance.com/ws/<KEY>')
  }

}
